export default {
  default: () => import("/home/app/snaprefund-frontend/layouts/Default.vue").then(m => m.default || m),
  "default-auth": () => import("/home/app/snaprefund-frontend/layouts/DefaultAuth.vue").then(m => m.default || m),
  "default-full-screen": () => import("/home/app/snaprefund-frontend/layouts/DefaultFullScreen.vue").then(m => m.default || m),
  "default-sign-up-steps": () => import("/home/app/base/layouts/DefaultSignUpSteps.vue").then(m => m.default || m)
}